module.exports = __webpack_public_path__ + "static/media/12.857e1a72.jpeg";